import i, { css as o } from "styled-components";
import { breakpoints as s } from "./atoms-v2125.js";
import { Base as p } from "./atoms-v2777.js";
const g = i.div`
  ${p}

  align-items: ${({ $vAlign: n }) => n || "start"};
  column-gap: var(--gap);
  display: flex;
  flex-wrap: ${({ $wrap: n }) => n || "wrap"};
  justify-content: ${({ $hAlign: n }) => n || "start"};
  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
  row-gap: ${({ $rowGap: n }) => n ? `${n}px` : 0};
  transform: ${({ $isRoot: n }) => n ? "translate3d(0, 0, 0)" : "none"};
  width: 100%;

  ${({ $colGap: n, $isRoot: t, theme: r }) => Object.keys(s).map((a) => o`
        @media ${s[a]} {
          --columns: ${r == null ? void 0 : r.get(`tokens.breakpoints.${a}.columns`)};
          --gap: ${typeof n == "number" ? `${n}px` : `${r == null ? void 0 : r.get(`tokens.breakpoints.${a}.gutter`)}px`};
          ${t && o`
            padding: 0 ${`${r == null ? void 0 : r.get(`tokens.breakpoints.${a}.margin`)}px`};
          `}
        }
      `)}
`;
export {
  g as Grid
};
